import { useRef, useState } from "react";

const PREFIX = "app:filter:";

function load(key: string): string[] {
  try {
    const raw = typeof localStorage !== "undefined" ? localStorage.getItem(PREFIX + key) : null;
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as string[]) : [];
  } catch {
    return [];
  }
}

function save(key: string, value: string[]) {
  try {
    if (value.length > 0) {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
    } else {
      localStorage.removeItem(PREFIX + key);
    }
  } catch {
    // ignore
  }
}

/**
 * Like useState<string[]> but persists the value in localStorage under `key`.
 * Returns [value, setter, ref] — the ref is always current, safe to read inside
 * async callbacks without stale-closure issues (same pattern as useServerSearch).
 */
export function usePersistedFilter(key: string): [string[], (next: string[]) => void, React.MutableRefObject<string[]>] {
  const initial = load(key);
  const [value, setValue] = useState<string[]>(initial);
  const ref = useRef<string[]>(initial);

  function set(next: string[]) {
    setValue(next);
    ref.current = next;
    save(key, next);
  }

  return [value, set, ref];
}
